"use client";

import * as React from "react";
import { ArrowRight, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const favorites = [{
  name: "מטפל סיעודי בבית",
  description: "ליווי מקצועי וחם בסביבה הביתית המוכרת, המותאם אישית לצרכי המטופל ומשפחתו לשיפור איכות החיים ברמה רפואית גבוהה לביתכם או בבתי חולים.",
  image: "https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/smiling_israeli_caregiver.png?v=ww8zi38cyzm",
  price: "זמינות מיידית"
}, {
  name: "השגחה בבית חולים",
  description: "שקט נפשי למשפחה בזמן אשפוז, עם מטפל צמוד 24/7 המעניק השגחה מלאה וסיוע בכל רגע נתון בשיבא, בילינסון, איכילוב.",
  image: "https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/hospital-supervision.png?v=05m6kby44zj",
  price: "הגעה תוך 5 שעות"
}, {
  name: "מטפל סיעודי פרטי",
  description: "מטפלים ישראלים בלבד, דוברי עברית ומנוסים, שנבחרו בקפידה כדי להעניק את הטיפול הטוב ביותר בתיווך רפואי מקצועי.",
  image: "https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/technician_pressure_washing_roof.png?v=r061gbw3oq",
  price: "ישראלים בלבד"
}, {
  name: "מטפל/ת לילה",
  description: "מענה מקצועי לשעות הלילה המאתגרות, המאפשר למשפחה לישון בשקט בידיעה שיקיריהם בידיים בטוחות שגחה רפואית צמודה.",
  image: "https://siudy.net/wp-content/uploads/2026/04/israeli_caregiver_patient_support.png?v=g3211um02it",
  price: "בפריסה ארצית"
}, {
  name: "ליווי לאחר ניתוח",
  description: "שיקום בתיווך רפואי",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/cast_iron_skillet.png",
  price: "שירות אישי"
}, {
  name: "מאות משפחות ממליצות",
  description: "הצטרפו למאות משפחות בישראל שכבר נעזרו בשירות המהיר והאמין שלנו ומצאו פתרון סיעודי הולם.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/kitchen_scale.png",
  price: "אמון מלא"
}];
export default function KitchenFavorites() {
  return <section data-section-id="194" id="emergencyandtrust" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-12 gap-6">
          <div className="max-w-2xl text-right md:text-right">
            <h2 className="font-default text-4xl md:text-5xl text-primary mb-4 tracking-tight">
              צריכים מטפל סיעודי עכשיו?
            </h2>
            <p className="text-muted-foreground font-default text-lg md:text-xl max-w-xl leading-relaxed">אצלנו לא צריך לחכות הרבה. אנו מספקים מטפלים סיעודיים ישראלים תוך עד 5 שעות בלבד, בפריסה ארצית מלאה לבית ולבית החולים.</p>
          </div>
          <div className="hidden md:block">
            <Button variant="outline" className="rounded-lg border-chart-3/20 bg-chart-3 hover:bg-chart-3/90 text-white shadow-lg transition-all" asChild>
              <Link to="tel:123456789">
                התקשרו עכשיו <ArrowRight className="ml-2 h-4 w-4 rotate-180" />
              </Link>
            </Button>
          </div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {favorites.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <Card className="h-full border-none bg-transparent group">
                  <CardContent className="p-0 h-full flex flex-col">
                    <div className="relative aspect-square overflow-hidden rounded-2xl bg-white mb-6 flex items-center justify-center p-8 transition-all duration-300 group-hover:shadow-xl border border-border/40">
                      <img src={item.image} alt={item.name} className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105" />
                      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="bg-chart-3/90 backdrop-blur-sm p-2 rounded-lg shadow-sm text-white">
                          <Star className="h-4 w-4 fill-current" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex flex-col flex-grow text-right">
                      <div className="flex justify-between items-start mb-2 flex-row-reverse">
                        <h3 className="font-default text-xl text-primary group-hover:text-chart-3 transition-colors duration-300">
                          {item.name}
                        </h3>
                        <span className="font-default text-xs font-semibold text-chart-3 bg-chart-3/10 px-2 py-1 rounded-md">
                          {item.price}
                        </span>
                      </div>
                      <p className="text-muted-foreground font-default text-sm leading-relaxed mb-4">
                        {item.description}
                      </p>
                      <p className="flex flex-wrap gap-x-3 gap-y-1 text-xs mb-4 flex-grow font-default">
                        <span className="text-chart-3">מטפל סיעודי</span>
                        <span className="text-chart-3">מטפל סיעודי בתל אביב</span>
                        <span className="text-chart-3">מטפל סיעודי בבית</span>
                        <Link to="/CaregiverServicePagesPage2" className="text-chart-3 hover:underline">השגחה בבית חולים</Link>
                      </p>
                      <Button variant="link" className="p-0 h-auto self-end text-chart-3 hover:text-chart-3/80 font-medium font-default" asChild>
                        <Link to={`/services/${item.name.replace(/\s+/g, "-")}`}>
                          למידע נוסף
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-3 mt-8 md:hidden">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-white border-border text-primary h-12 w-12 shadow-md" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-white border-border text-primary h-12 w-12 shadow-md" />
          </div>
          <div className="hidden md:block">
             <CarouselPrevious className="left-0 -translate-x-1/2 bg-background/80 backdrop-blur-sm hover:bg-background border-border text-primary" />
             <CarouselNext className="right-0 translate-x-1/2 bg-background/80 backdrop-blur-sm hover:bg-background border-border text-primary" />
          </div>
        </Carousel>

        <div className="mt-8 md:hidden sticky bottom-0 z-50 pb-4">
          <Button variant="outline" className="w-full h-12 px-6 rounded-lg bg-chart-2 text-white border-none shadow-md font-default font-bold" asChild>
            <Link to="https://wa.me/123456789">
              בדיוק כמו מטפל בבית חולים
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}